<h3 *ngIf="location$ | async as location">{{ location.tag }}: {{ location.name }}</h3>
